<div class="md:mx-auto w-full md:max-w-md">
  <div
    *ngIf="amountLeft !== 0; else loading"
    class="mt-3 px-5"
  >
    <div class="flex justify-between mt-6 pb-3">
      <span class="font-base font-bold text-neutral-800">
        {{ 'group-payments.total' | translate }}
      </span>
      <app-price-atom
        [amount]="totalAmount"
        format="true"
      ></app-price-atom>
    </div>
    <div
      *ngIf="(transactions$ | async)?.length === 0"
      class="mt-28"
    >
      <p>
        {{ 'group-payments.empty-list-message' | translate }}
      </p>
      <p>
        {{ 'group-payments.empty-list-message-2' | translate }}
      </p>
    </div>
    <ng-container *ngIf="transactions$ | async as groupedTransactions">
      <ul *ngIf="groupedTransactions.length > 0">
        <li
          class="pt-7"
          *ngFor="let groupedTransaction of groupedTransactions"
        >
          <p class="pb-3 text-neutral-600 text-sm">
            <ng-container
              *ngIf="
                !groupedTransaction.user.firstname && !groupedTransaction.user.lastname;
                else fullname
              "
              >{{ 'basket.anonymous' | translate }}</ng-container
            >
            <ng-template #fullname>
              {{ groupedTransaction.user.firstname }}
              {{ groupedTransaction.user.lastname }}
            </ng-template>
            <ng-container *ngIf="(userId$ | async) === groupedTransaction.user.id">
              ({{ 'basket.you' | translate }})
            </ng-container>
          </p>
          <div
            class="flex justify-between pb-2"
            *ngFor="let transaction of groupedTransaction.transactions"
          >
            {{ transaction.payment_method | paymentMethodLabel | translate }}
            <app-price-atom
              [amount]="-transaction.amount"
              [bold]="false"
              format="true"
            ></app-price-atom>
          </div>
        </li>
      </ul>
      <div
        *ngIf="groupedTransactions.length > 0"
        class="pt-8 text-center w-full text-neutral-600 text-sm"
        translate="group-payments.automatic-redirect-notice"
      ></div>
    </ng-container>
    <div class="hidden md:block">
      <div class="flex justify-between pb-4">
        <span class="font-base font-bold text-neutral-800">
          {{ 'group-payments.amount-left' | translate }}
        </span>
        <app-price-atom
          [amount]="amountLeft"
          format="true"
        ></app-price-atom>
      </div>
      <div>
        <app-button-atom
          [disabled]="amountLeft === 0"
          [label]="'group-payments.add-payment' | translate"
          [type]="'primary'"
          [size]="'L'"
          (click)="addPayment()"
        ></app-button-atom>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="mt-3 px-5">
      <div
        class="animate-pulse py-1.5 mb-2 rounded-lg overflow-hidden relative bg-neutral-100"
      ></div>
      <div class="w-full flex justify-between mb-">
        <p class="w-4/12 animate-pulse mb-1.5 py-1.5 bg-neutral-100"></p>
        <p class="w-2/12 animate-pulse py-1 bg-neutral-100"></p>
      </div>
    </div>
    <div class="mt-28 px-5">
      <p class="w-full animate-pulse py-1 bg-neutral-50"></p>
      <p class="w-2/12 animate-pulse py-1 bg-neutral-50"></p>
      <div class="w-full flex justify-between mb-">
        <p class="w-4/12 animate-pulse mb-1.5 py-1.5 bg-neutral-100"></p>
        <p class="w-2/12 animate-pulse py-1 bg-neutral-100"></p>
      </div>
    </div>
  </ng-template>
</div>

<div class="md:hidden fixed right-0 left-0 bottom-0 shadow z-30 shadow-top bg-white">
  <div class="w-full mx-auto p-4 pt-4.5 align-middle">
    <div class="flex justify-between pb-4">
      <span class="font-base font-bold text-neutral-800">
        {{ 'group-payments.amount-left' | translate }}
      </span>
      <img
        *ngIf="!isLoaded || amountLeft === 0"
        src="assets/images/spinner.svg"
        alt=""
        class="p-2 mr-2"
      />
      <app-price-atom
        *ngIf="isLoaded && amountLeft > 0"
        [amount]="amountLeft"
        format="true"
      ></app-price-atom>
    </div>
    <div>
      <app-button-atom
        [disabled]="amountLeft === 0"
        [label]="'group-payments.add-payment' | translate"
        [type]="'primary'"
        [size]="'L'"
        (click)="addPayment()"
      ></app-button-atom>
    </div>
  </div>
</div>
